<template>
    <div class="campaign-card" @click="clickCampaign()">
        <div class="campaign-card-img">
            <img :src="campaign.fullImageUrl"/>
            <div v-if="campaign.qty == 0">
                <div class="bg-campaign-sold-out"></div>
                <div class="campaign-sold-out">
                    <div class="sold-out">
                        <div class="text-sold-out">Sold out</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="discount" v-if="campaign.discount > 0">
            <div class="discount-img">
                <img src="@/assets/new/bg/bg-discount.png"/>
                <div class="discount-text">
                    <div class="text">ลด</div>
                    <div class="text">{{ campaign.discount }}%</div>
                </div>
            </div>
        </div>
        <div class="campaign-card-info">
            <div class="campaing-name">{{campaign.name}}</div>
            <div class="price-card">
                <div class="price-info">
                    <div class="price-unit">{{getUnit()}}</div>
                    <div class="original-price" v-if="blobConfig.app_redeem_type != 'point'">{{getOriginalPrice()}}</div>
                </div>
                <div class="add-card">
                    <img v-if="campaign.qty != 0" src="@/assets/new/icon/ic-add-card-active.png"/>
                    <img v-else src="@/assets/new/icon/ic-add-card-inactive.png"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility";
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: 'MyWishListSItem',
    mixins: [LocaleMixin],
    props: {
        index: Number,
        campaign: Object
    },
    data: function() {
        return {
            campaignName: '',
        };
    },
    created: function() {
        this.blobConfig = Account.getCacheBlob("BlobConfig")

        this.campaignName = this.localeCode == 1054 ? this.campaign.nameTh : this.campaign.nameEn;
    },
    mounted: function () {

    },
    methods: {
        //event
        clickCampaign: function () {
            //GA
            var path = '/campaign/' + this.campaign.id;
            this.$router.push(path);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },
        getUnit: function() {
            if (this.blobConfig.app_redeem_type == "point") {
                return Util.stringFormat(this.lbl.B2B.campaign.point,Util.formatNum(Number(this.campaign.pointPerUnit)));
            } else {
                return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.pricePerUnit)));
            }
        },
        getOriginalPrice: function () {
            return Util.stringFormat(this.lbl.B2B.campaign.price,Util.formatNum(Number(this.campaign.originalPrice)));
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
@import "./MyWishListItem.scss";

    .discount {
            position: absolute;
            top: 0px;
            right: 0px;
            .discount-img{
                position: relative;
                img {
                    width: 100%;
                    max-width: 30px;
                    height: auto;
                }
            }
            .discount-text {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                display: grid;
                grid-column: 1;
                font-size: $px10;
                color: white;
                .text {
                    display: flex;
                    justify-content: center;
                }
            }
    }
</style>
